import { HttpService } from './service/httpservice';
import { WsService } from './service/websocket';
import { WebService } from './service/webservice';
import { Utils } from './service/utils';
import { StorageService } from './service/storageservice';
import { LoginFilter } from './service/loginfilter';
import { ShareModel} from './model/sharemodel';
import { UserInfoModel} from './model/users';

import { OrderBy } from './service/orderby';
import { JpushService } from './service/jpushservice';

import { MachineType } from './util/machine';
import { ToastAlert } from './util/toastalert';
import {MsgUtils} from './util/msgutils';
import {PlatformUtils} from './util/platformutils';
import {VersionService} from './util/versionservice';


/*********
 * 服务、方法配置，设置
 *
 * ***********/
export const SERVCICETS = [
  HttpService,
  WsService,
  WebService,
  JpushService,
  Utils,
  MachineType,
  ToastAlert,
  StorageService,
  LoginFilter,
  ShareModel,UserInfoModel,
  MsgUtils,
  PlatformUtils,
  VersionService
];


export const SERVCICEEX = [
  OrderBy
];



// WEBPACK FOOTER //
// ./src/providers/service.ts